import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.FILE_SET_UPLOAD_URL]: (state, payload) => {
    state.uploadUrl = payload.uploadUrl
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_TOTAL]: (state, payload) => {
    state.csvUploadTotal = payload.total
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_ERROR_LIST]: (state, payload) => {
    state.csvUploadErrorList = payload.errorList
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_HISTORY_LIST]: (state, payload) => {
    state.csvUploadHistoryList = payload.data.exCsvFileList
  }
}

export default Mutations
